module.exports = __webpack_public_path__ + "static/media/topImg.f0b5abfd.png";